import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const StatWrap = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  margin: auto;
  background: ${color.common.white};
  p {
    margin-bottom: 0;
  }
`

export const StatHead = styled.h3`
  font-weight: 800;
  font-size: 36px;
  line-height: 44px;
  text-align: center;
  letter-spacing: -0.02em;
  color: ${color.oxfordBlue[900]};
  @media (max-width: 992px) {
    font-size: 24px;
    line-height: 32px;
  }
  @media (max-width: 576px) {
    font-size: 20px;
    line-height: 30px;
  }
`

export const StatBody = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${color.copy[600]};
  @media (max-width: 576px) {
    font-weight: 350;
  }
`
